const NETWORK_ALIASES =
  '(yd|yandexdirect|google-ads|targetmail|vk|adsmarket|tiktok|facebook|pornhub|yahoo|directadvert|marketgid|yandex-business|zeropark|sape|snapchat|adsterra|mytargetint|taboola|yandex-zen|vk-ads|adgram|otm|telegram-ads|bigo-ads|mobidriven|appnext|avito|trafficjunky|yandex-geoadv|yandex-market|ozon-performance|petal-ads|mi-ads|apple-search-ads|unity-ads|microsoft-advertising|wowblogger|vk-adblogger|google-high-risk|facebook-high-risk|two-gis|ad-god|sber-ads|avito-ads|yandex-urban-ads)'

const PAYMENT_RESULTS_PARTNERS = '(capitalist|contact-pay)'

export { NETWORK_ALIASES }

export default {
  MAIN: '/:i18n',

  AGENCY: '/:i18n/agency',
  AGENCY_CLIENTS: '/:i18n/agency/clients',
  AGENCY_ADD_CLIENT: '/:i18n/agency/clients/add-client',
  ADD_AGENCY: '/:i18n/agency/add',
  AGENCY_ADD_CLIENT_SUCCESS: '/:i18n/agency/clients/add-client-success',
  AGENCY_REQUESTS: '/:i18n/agency/requests',
  AGENCY_TRANSFER: '/:i18n/agency/clients/:id/transfer',

  AUTH_REGISTRATION: '/:i18n/register',
  AUTH_LOGIN: '/:i18n/login',
  AUTH_LOGOUT: '/:i18n/logout',
  AUTH_ACTIVATION: '/:i18n/activation/activate/:token',
  AUTH_RECOVER: '/:i18n/recover',
  AUTH_RECOVER_WITH_EMAIL: '/:i18n/recover/:email',
  AUTH_RECOVER_SENT: '/:i18n/recover/sent/:email',
  AUTH_RECOVER_SET_PASSWORD: '/:i18n/recover/:email(\\S+@\\S+\\.\\S+)/:token',
  AUTH_LOGIN_2FA: '/:i18n/login/2fa',
  AUTH_ADMITAD_CHECK: '/security/admitad/check',
  AUTH_ADMITAD_AUTH: '/security/admitad/auth',

  BILLING: '/:i18n/billing',
  BILLING_TOP_UP: '/:i18n/billing/top-up',
  BILLING_TOP_UP_ACCOUNTS: '/:i18n/billing/:networkType/top-up/accounts',
  BILLING_DEPOSIT: '/:i18n/billing/:networkType/deposit/',
  BILLING_TOP_UP_ACCOUNT: '/:i18n/billing/top-up/:accountId([0-9]+)',
  BILLING_TOP_UP_RESULT: '/:i18n/billing/top-up/:type(success|failure)',
  BILLING_PAYMENT_RESULT: '/:i18n/billing/payment/:type(success|failure)',
  BILLING_DEPOSIT_CREATION_FEE: '/:i18n/billing/deposit-commission/:accountId([0-9]+)',
  BILLING_MARKETPLACE_PRODUCT_PAYMENT:
    '/:i18n/billing/marketplace-account/top-up/:productId([0-9]+)',
  BILLING_BANK_CARDS_TOP_UP: '/:i18n/billing/virtual-cards/:cardId([0-9]+)/top-up',
  BILLING_BANK_CARDS_CREATION_FEE: '/:i18n/billing/virtual-cards/:cardId([0-9]+)/create',

  FINANCE: '/:i18n/finance',
  FINANCE_WALLETS: '/:i18n/finance/wallets',
  FINANCE_WALLET: '/:i18n/finance/wallets/:walletID',
  FINANCE_WALLET_PROMISED_PAYMENTS: '/:i18n/finance/wallets/:walletID/promised-payments',
  FINANCE_PAYMENT_PROFILES: '/:i18n/finance/payment-profiles',
  FINANCE_PAYMENT_PROFILE_NEW: '/:i18n/finance/payment-profiles/new',
  FINANCE_PAYMENT_PROFILE_SHOW: '/:i18n/finance/payment-profiles/:profileId([0-9]+)/show',
  FINANCE_PAYMENT_PROFILE_EDIT: '/:i18n/finance/payment-profiles/:profileId([0-9]+)/edit',
  FINANCE_INVOICES: '/:i18n/finance/invoices',
  FINANCE_PROMISED_PAYMENT: '/:i18n/finance/promised-payment',
  FINANCE_PROMISED_PAYMENT_REQUEST: '/:i18n/finance/promised-payment/request',

  OAUTH_CODE: '/oauth/v2/code',
  OAUTH_AUTH: '/oauth/v2/auth',

  PAYMENT_ORDER: '/:i18n/payment-order/:id',

  REFERRALS: '/:i18n/referrals',
  REFERRAL: '/:i18n/referral',
  REFERRAL_PAYOUT: '/:i18n/referral/payout',
  REFERRAL_PAYOUT_PROFILES: '/:i18n/referral/payout-profiles',
  REFERRAL_PAYOUT_PROFILE_NEW: '/:i18n/referral/payout-profiles/new',
  REFERRAL_PAYOUT_PROFILE_EDIT: '/:i18n/referral/payout-profiles/:profileId([0-9]+)/edit',
  REFERRAL_PAYOUT_PROFILE_INVOICES: '/:i18n/referral/payout-profiles/:profileId([0-9]+)/invoices',

  REFERRAL_CLIENTS: '/:i18n/referral/clients',
  REFERRAL_CLIENTS_EDIT: '/:i18n/referral/clients/:id([0-9]+)/edit',
  REFERRAL_LINKS: '/:i18n/referral/links',
  REFERRAL_LINKS_CREATE: '/:i18n/referral/links/create',
  REFERRAL_LINKS_EDIT: '/:i18n/referral/links/:linkId([0-9]+)/edit',

  SERVICES: '/:i18n/services/',
  SERVICES_NETWORK: `/:i18n/services/:networkType${NETWORK_ALIASES}`,
  SERVICES_NETWORK_META_PIXELS: '/:i18n/services/:networkType(facebook-high-risk)/meta-pixels',
  SERVICES_NETWORK_MEDIA_PLANNER: `/:i18n/services/:networkType${NETWORK_ALIASES}/media-planner`,
  SERVICES_NETWORK_ACCOUNT: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)`,
  SERVICES_NETWORK_ACCOUNT_REGISTER: `/:i18n/:networkType${NETWORK_ALIASES}/register`,
  SERVICES_NETWORK_CAMPAIGNS_EDITOR_DEFAULT: `/:i18n/services/:networkType${NETWORK_ALIASES}/campaigns-editor`,
  SERVICES_NETWORK_CAMPAIGNS_EDITOR: `/:i18n/services/:networkType${NETWORK_ALIASES}/campaigns-editor/:resource`,
  SERVICES_NETWORK_CAMPAIGNS_EDITOR_CAMPAIGNS: `/:i18n/services/:networkType${NETWORK_ALIASES}/campaigns-editor/:resource(campaigns)`,
  SERVICES_NETWORK_CAMPAIGNS_EDITOR_AD_GROUPS: `/:i18n/services/:networkType${NETWORK_ALIASES}/campaigns-editor/:resource(ad-groups)`,
  SERVICES_NETWORK_CAMPAIGNS_EDITOR_BANNERS: `/:i18n/services/:networkType${NETWORK_ALIASES}/campaigns-editor/:resource(banners)`,

  SERVICES_NETWORK_ACCOUNT_MULTIREGISTER: `/:i18n/:networkType${NETWORK_ALIASES}/register/multiple`,
  SERVICES_NETWORK_AUTH: `/:i18n/:networkType${NETWORK_ALIASES}`,
  SERVICES_NETWORK_ACCOUNT_REFUND: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/refund`,
  SERVICES_NETWORK_ACCOUNT_ADVERTISER_INFO_EDIT: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/advertiser-info/edit`,
  SERVICES_NETWORK_ACCOUNT_ACCESS: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/access`,
  SERVICES_NETWORK_ACCOUNT_ACCESS_NEW: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/access/new`,
  SERVICES_NETWORK_ACCOUNT_ACCESS_EDIT: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/access/:id([0-9]+)/edit`,
  SERVICES_NETWORK_ACCOUNT_CAMPAIGNS: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/campaigns`,
  SERVICES_NETWORK_ACCOUNT_CAMPAIGN_NEW: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/campaigns/new`,
  SERVICES_NETWORK_ACCOUNT_CAMPAIGN: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/campaigns/:campaignId([0-9]+)`,
  SERVICES_NETWORK_ACCOUNT_CAMPAIGN_START: `/:i18n/services/:networkType${NETWORK_ALIASES}/:accountId([0-9]+)/campaigns/:campaignId([0-9]+)/start`,

  STATISTICS: '/:i18n/statistics/',
  STATISTICS_ACCOUNT: '/:i18n/statistics/:network/:externalId([0-9]+)',
  STATISTICS_CAMPAIGN: '/:i18n/statistics/:network/:accountExternalId([0-9]+)/:campaignId([0-9]+)',
  STATISTICS_ACCOUNT_CONNECT: '/:i18n/statistics/accounts/connect',

  TICKETS: '/:i18n/tickets',
  TICKET_NEW: '/:i18n/tickets/new',
  TICKET: '/:i18n/tickets/:id([0-9]+)',

  USER: '/:i18n/user/',
  USER_SETTINGS: '/:i18n/user/settings',
  USER_ACCOUNTS: '/:i18n/user/accounts',
  USER_ADMITAD_ATTACH: '/:i18n/user/admitad/attach',
  USER_SECURITY: '/:i18n/user/security',
  USER_SECURITY_PASSWORD: '/:i18n/user/security/password',
  USER_SECURITY_2FA: '/:i18n/user/security/2fa',
  USER_SECURITY_2FA_SETTING: '/:i18n/user/security/2fa/setup',

  QIWI_SUCCESS: '/qiwi/success',
  QIWI_DECLINE: '/qiwi/decline',

  PAYMASTER_SERVICE_RESULT: '/paymaster-service/:type(result)',
  PAYMENT_RESULT: `/${PAYMENT_RESULTS_PARTNERS}/:type(success|failure)`,

  TARGETMAIL_AUTH: '/targetmail/auth/',

  VK_AUTH: '/vk/auth/',
  VK_CODE: '/vk/code/',
  VK_ADS_CODE: '/vk-ads/code',
  TARGET_MAIL_CODE: '/login/target-check',

  YANDEX_ADS_CODE: '/yd/code',

  ADSMARKET_AUTH: '/:i18n/adsmarket/auth/',
  ADSMARKET_CODE: '/:i18n/adsmarket/code/',

  AUTOREPLENISH: '/:i18n/auto-replenish/:accountId([0-9]+)',

  TERMS_OF_USE: '/:i18n/services/:networkType/terms-of-use',

  PROMISED_PAYMENT_TERMS: '/:i18n/promised-payment-terms',

  PRIVACY_POLICY: '/:i18n/privacy-policy',
  CONTACTS: '/:i18n/contacts',

  //для локального эмулирования онлайн кассы
  LOCAL_PAY: '/:i18n/pay/:hash',

  BLOG_URL: '/blog/',

  BANK_CARDS: '/:i18n/virtual-cards',
  BANK_CARDS_CREATE_CARD: '/:i18n/virtual-cards/create',
  BANK_CARDS_CARD: '/:i18n/virtual-cards/:cardId([0-9]+)',

  CABINET_FAQ: '/:i18n/help',
  CABINET_FAQ_CATEGORY: '/:i18n/help/categories/:categoryId([a-zA-Z0-9-]+)',
  CABINET_FAQ_ARTICLE: '/:i18n/help/articles/:articleId([a-zA-Z0-9-]+)',
}
